import type {UserSettingsOptionConfig} from '@github-ui/issue-create/getSafeConfig'
import {ThreePanesLayout} from '@github-ui/three-panes-layout'

import styles from './MilestoneCreate.module.css'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {MilestoneError} from './MilestoneError'
import {LABELS} from './constants/labels'
import {MilestoneCreateForm} from './components/MilestoneCreateForm'
import type {MilestoneCreateFormRepositoryQuery$key} from './components/__generated__/MilestoneCreateFormRepositoryQuery.graphql'

type MilestoneCreateProps = {
  repository: MilestoneCreateFormRepositoryQuery$key
  optionConfig?: UserSettingsOptionConfig
}

export function MilestoneCreate(props: MilestoneCreateProps) {
  return (
    <ThreePanesLayout
      contentAs="div"
      resizeable={false}
      leftPaneWidth="small"
      middlePane={
        <div className={styles.middlePaneWrapper}>
          <ErrorBoundary
            fallback={<MilestoneError title={LABELS.milestonesError} message={LABELS.milestonesErrorMessage} />}
          >
            <MilestoneCreateForm {...props} />
          </ErrorBoundary>
        </div>
      }
    />
  )
}

try{ MilestoneCreate.displayName ||= 'MilestoneCreate' } catch {}